import React, { useState } from 'react';
import {
    Box,
    Checkbox,
    FormControlLabel,
    FormHelperText,
    Typography
} from '@mui/material';

const DEFAULT_PRODUCT_CONFIRMATION =
    'By submitting this product, you confirm that all information provided is accurate ' +
    'to the best of your knowledge. You also agree that the content, including images ' +
    'and descriptions, does not contain any harmful, misleading, or inappropriate ' +
    'material. Any violation may result in removal of the listing and/or further action.';

export default function ConfirmationCheckbox(props) {
    const {
        agreed,
        setAgreed,
        confirmationText = DEFAULT_PRODUCT_CONFIRMATION,
        mustConfirmMessage = 'You must confirm before submitting.',
        boxSx = { mt: 3, maxWidth: 600 },
    } = props;
    const [touched, setTouched] = useState(false);

    const handleChange = (e) => {
        setAgreed(e.target.checked);
        setTouched(true);
    };

    const error = touched && !agreed;

    return (
        <Box sx={boxSx}>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={agreed}
                        onChange={handleChange}
                        sx={{
                            color: error ? 'red' : 'rgb(24, 20, 54)',
                            '&.Mui-checked': {
                                color: 'rgb(24, 20, 54)',
                            },
                        }}
                    />
                }
                label={
                    <Typography variant="body2" sx={{ color: error ? 'red' : 'inherit' }}>
                        {confirmationText}
                    </Typography>
                }
            />
            {error && (
                <FormHelperText sx={{ color: 'red', margin: '10px 0px 0px 30px', fontFamily: 'Inter Bold' }}>
                    {mustConfirmMessage}
                </FormHelperText>
            )}
        </Box>
    );
}